import React, { useState, useEffect, useCallback, useMemo } from "react";
import format from "date-fns/format";

import { useAxios } from "../hooks/useAxios";
import "./gis.scss";

import { Formik } from "formik";
import moment from "moment";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers";

import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import {
  Male,
  FemaleTwoTone,
  TwoWheeler,
  Visibility,
  TransgenderTwoTone,
  Colorize,
  Bolt,
  Diversity1Rounded,
  LocalHospitalSharp,
  ThumbUp,
} from "@mui/icons-material";
import HomeTwoToneIcon from "@mui/icons-material/HomeTwoTone";
import { BiRename } from "react-icons/bi";
import { AiOutlineCaretRight, AiOutlineCaretLeft } from "react-icons/ai";

import {
  LocalHospital,
  Festival,
  HowToReg,
  DirectionsBike,
  RestartAlt,
  ArrowLeft,
  ArrowRight,
  AssignmentInd,
} from "@mui/icons-material";

// import { FieldWorkerMap, CampMap, HospitalMap, CommonMap } from "./Maps";
import { CommonMap as Map } from "./Maps";

import {
  Typography,
  TextField,
  MenuItem,
  InputLabel,
  Button,
  Input,
  Autocomplete,
} from "@mui/material";

import { createFilterOptions } from "@mui/material/Autocomplete";
import cataractdia from "../assets/cataractdia.png";
import cataracthyper from "../assets/cataracthyper.png";
import cataracthyperdia from "../assets/cataracthyperdia.png";
import diahper from "../assets/diahyper.png";
import logo from "../assets/icon.png";

import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import { icons } from "react-icons/lib";
import { useNavigate } from "react-router-dom";

const state = {
  // fromDate: "",
  // toDate: "",
  hospital_id: [],
  field_worker_id: "",
  camp_id: [],
};
const dateFormat = process.env.REACT_APP_DATE_FORMAT;

const renderInputs = (props, placeholder, classname) => (
  <Input
    sx={{
      input: {
        "&::placeholder": {
          // <----- Add this.
          opacity: 1,
          // marginBottom: '-5px',
          paddingLeft: "10px",
          fontSize: "13px",
          color: "#000000",
        },
        width: "80%",
      },
      backgroundColor: "#ffffff",
      // borderRadius: '5px',
      maxHeight: "50px",
    }}
    type="text"
    className={classname}
    inputRef={props.inputRef}
    // inputProps={props.inputProps}
    inputProps={{
      ...props.inputProps,
      placeholder: placeholder,
    }}
    value={props.value}
    onClick={props.onClick}
    onChange={props.onChange}
    endAdornment={props.InputProps?.endAdornment}
  />
);

const filter = createFilterOptions();

// Default state objects defined outside component to prevent recreation on every render
const filterdate = { fromDate: "", toDate: "" };
const defaultMapDates = { minDate: null, maxDate: null };
const camps = { vhv: [], cbbf: [] };
const fW = { vhv: null, cbbf: null };
const ill = {
  cataract: null,
  surgerydonedetails: null,
  diabetes: null,
  none: null,
  hypertension: null,
  asthma: null,
  cataractDia: null,
  cataractHyper: null,
  HyperDia: null,
  cataractHyperDia: null,
};
const shifts = { shiftIn: null, shiftout: null };

// Single source of truth for "a full date range is selected".
// Empty sentinel is "" (see filterdate); a cleared picker must also produce "".
const hasDateRange = (range) => Boolean(range?.fromDate && range?.toDate);

const patientsD = {
  vhv: null,
  cbbf: null,
  male: 0,
  female: 0,
  others: 0,
  household: 0,
  individual: 0,
  camp: 0,
};

const Gis_report = ({}) => {
  const { axios } = useAxios();

  const navigate = useNavigate();

  const [expand, setExpand] = useState(1);
  const [initialValues, setInitialValue] = useState(state);
  const [trackingDate, setTrackingDate] = useState();
  const [hospitals, setHospitals] = useState(null); //hospital dropdown
  const [villages, setVillages] = useState([]);
  const [filter, setFilter] = useState(true);
  const [filtered, setFiltered] = useState(0);
  const [village_id, setVillageId] = useState("");

  const [initialDate, setInitailDate] = useState(filterdate);

  const [date, setDate] = useState(defaultMapDates);

  //camp list on camp map
  const [camp, setCamp] = useState(camps);

  //reset

  const [fieldreset, setFieldreset] = useState({
    vhv: 1,
    cbbf: 2,
  });
  const [campreset, setCampreset] = useState({
    vhv: 5,
    cbbf: 6,
  });
  const [reset, setReset] = useState(false);
  const [villagereset, setVillageReset] = useState(8);

  //fieldworkers list on field worker map

  const [fieldWorkers, setFieldWorkers] = useState(fW);

  const [illness, setIllness] = useState({ ...ill }); //common illness
  const [hospitalData, setHospitalData] = useState(null); // hospital name and other detail
  const [houseHoldData, setHouseHoldData] = useState(null); // household detail
  const [campData, setCampData] = useState(null); // campdata to google map
  const [campDetail, setCampDetail] = useState(null); // camp detail to show panel
  const [campDataDetail, setcampDataDetail] = useState([]); //hospital related camp detail
  const [campRHouse, setcampRhouse] = useState(true); // camp and house detail

  const [allTrackData, setAllTrackData] = useState(null); // all days fieldworker data to google map
  const [trackDetail, setTrackDetail] = useState(0); // field worker detail for right panel
  const [daytrack, setDayTrack] = useState(null); // particular date tracking date
  const [fieldWorkerName, setfieldWorkerName] = useState(null); // fieldworker name detail
  const [hosCamp, sethosCamp] = useState([]); //hospital camp data

  const [shiftdetail, setshiftdetail] = useState(shifts);

  const [patientDetails, setPatientDetails] = useState(patientsD);

  const MAP_RESTRICTION = {
    // world map bound restriction
    latLngBounds: {
      north: 37.6,
      south: 6.4,
      west: 68.7,
      east: 97.25,
    },
  };

  const [selectedIll, setSelectedIll] = useState(null);

  useEffect(() => {
    var hospital = localStorage.getItem("hospital_id");
    var role_id = localStorage.getItem("role_id");
    if (role_id == "7") {
      var data;
      data = {
        hospital_id: [hospital],
      };
      loadHospital(data);
      // handleFieldWorkerDropdown(data)
      // handleCampDropdown(data);
      // loadVillages(data)
      // Seed the hospital filter from localStorage without mutating state
      // directly. Replace (not append): this effect re-runs on reset and on
      // StrictMode double-mount, and appending would duplicate the id.
      setInitialValue((prev) => ({
        ...prev,
        hospital_id: [hospital],
      }));
    } else {
      var dates = {
        fromDate: new Date(),
        toDate: new Date(),
      };
      setTimeout(() => {
        loadTodayCamp(dates);
      }, 2000);

      // campSurveyList(dates)
      loadHospital(initialValues);
      // handleFieldWorkerDropdown(initialValues)
      // handleCampDropdown(initialValues)
      // loadVillages(initialValues)
    }
  }, [reset]);

  // Refetch illness data whenever the applied filters change.
  // IDs "1"/"2" are Select-All sentinels, not real Mongo ObjectIds: they must
  // never reach the backend (ObjectId cast throws a 500). Their expanded
  // fetch is done in handleTrack / handleCampAndFieldWorker with real ids.
  // Branches are mutually exclusive so only ONE request fires per change —
  // overlapping requests raced each other and the last response won.
  useEffect(() => {
    const hospitalSelected =
      Array.isArray(initialValues.hospital_id) &&
      initialValues.hospital_id.length > 0 &&
      initialValues.hospital_id[0] !== "1";
    const campIsSelectAll =
      Array.isArray(initialValues.camp_id) &&
      (initialValues.camp_id[0] === "1" || initialValues.camp_id[0] === "2");
    const campSelected =
      Array.isArray(initialValues.camp_id) &&
      initialValues.camp_id.length > 0 &&
      !campIsSelectAll;

    if (campIsSelectAll) {
      // Select-All: handleCampAndFieldWorker already fetched with the real,
      // date-filtered camp ids. Fetching again here (e.g. hospital-wide,
      // undated) would race that request and overwrite its result.
      return;
    }
    if (initialValues.field_worker_id !== "") {
      handleIllness({ field_worker_id: initialValues.field_worker_id });
    } else if (hospitalSelected && campSelected) {
      handleIllness({
        hospital_id: initialValues.hospital_id,
        camp_id: initialValues.camp_id,
      });
    } else if (campSelected) {
      handleIllness({ camp_id: initialValues.camp_id });
    } else if (hospitalSelected) {
      handleIllness({ hospital_id: initialValues.hospital_id });
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialValues]);

  useEffect(() => {
    if (village_id != "") {
      var data = {
        village_id: village_id,
      };
      // Include date range if already selected so village data is date-filtered
      if (hasDateRange(initialDate)) {
        data.fromDate = initialDate.fromDate;
        data.toDate = initialDate.toDate;
      }
      handleIllness(data, "local");
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [village_id]);

  useEffect(() => {
    if (hasDateRange(initialDate)) {
      var payload = {
        fromDate: initialDate.fromDate,
        toDate: initialDate.toDate,
      };
      // If a hospital is already selected, include it so camps are filtered by hospital + date
      if (
        initialValues.hospital_id?.length > 0 &&
        initialValues.hospital_id[0] !== ""
      ) {
        payload.hospital_id = initialValues.hospital_id;
      }
      // Reset camp selections when date range changes so fresh data is shown.
      // The applied filters (camp_id / field_worker_id) must be cleared together
      // with the visible dropdowns, otherwise later payloads keep filtering by a
      // camp the user can no longer see selected.
      setCamp({ vhv: [], cbbf: [] });
      if (
        initialValues.camp_id?.length > 0 ||
        initialValues.field_worker_id !== ""
      ) {
        setInitialValue((prev) => ({
          ...prev,
          camp_id: [],
          field_worker_id: "",
        }));
        setCampDetail(null);
      }
      handleCampDropdown(payload);

      // If a village is already selected, re-fetch its illness data with the new date range
      if (village_id !== "") {
        var villagePayload = {
          village_id: village_id,
          fromDate: initialDate.fromDate,
          toDate: initialDate.toDate,
        };
        handleIllness(villagePayload, "local");
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialDate.fromDate, initialDate.toDate]);

  async function loadHospital(list) {
    await axios.post("getGISHospitalList", list).then((res) => {
      // result can be missing/empty — spreading undefined throws
      var hospitals = res?.data?.result?.result || [];

      var select = { hospital_name: "Select All", hospital_id: "1" };

      const sortedHospitals = hospitals.sort((a, b) =>
        (a.hospital_name || "").localeCompare(b.hospital_name || "")
      );

      const finalHospitals = [select, ...sortedHospitals];

      setHospitals(finalHospitals);
    });
  }

  async function loadTodayCamp(data) {
    await axios.post("getCampSurveyList", data).then((res) => {
      var data_ = res.data.result;
      sethosCamp(data_);
    });
  }

  async function loadVillages(data) {
    await axios.post("getVillageList", data).then((res) => {
      // result may be an empty array (hospital with no villages)
      var villageList = res?.data?.result?.[0]?.village || [];
      setVillages(villageList);
    });
  }

  const handleIllness = useCallback(
    // NOTE: second arg must not be named "ill" — it would shadow the
    // module-level `ill` defaults object used to reset on empty results.
    async (data, mode) => {
      await axios.post("getIllnessList", data).then((res) => {
        // Guard every level: an empty result set must render as zeros,
        // not crash the page.
        var value = res?.data?.result?.result;
        if (!value) {
          setIllness({ ...ill });
          return value;
        }
        setIllness((prevIllness) => ({
          ...prevIllness,
          diabetes: value.FinalD?.[0] != undefined ? value.FinalD[0] : 0,
          none: value.None != undefined ? value.None : 0,
          hypertension: value.FinalH?.[0] != undefined ? value.FinalH[0] : 0,
          asthma: value.Asthma != undefined ? value.Asthma : 0,
          surgerydonedetails:
            value.surgeryDoneDetails != undefined
              ? value.surgeryDoneDetails
              : 0,
          cataract: value.FinalC?.[0] != undefined ? value.FinalC[0] : 0,
          cataractDia: value.FinalCD?.[0] != undefined ? value.FinalCD[0] : 0,
          cataractHyperDia:
            value.FinalCDH?.[0] != undefined ? value.FinalCDH[0] : 0,
          cataractHyper: value.FinalCH?.[0] != undefined ? value.FinalCH[0] : 0,
          HyperDia: value.FinalDH?.[0] != undefined ? value.FinalDH[0] : 0,
        }));

        return value;
      });
    },
    [setIllness]
  );

  /* async function handleIllness(data, ill) {
    await axios.post("getIllnessList", data).then((res) => {
      var value = res.data.result.result;
      setIllness({
        ...illness,
        diabetes: value.FinalD[0] != undefined ? value.FinalD[0] : 0,
        none: value.None != undefined ? value.None : 0,
        hypertension: value.FinalH[0] != undefined ? value.FinalH[0] : 0,
        asthma: value.Asthma != undefined ? value.Asthma : 0,
        surgerydonedetails:
          value.surgeryDoneDetails != undefined ? value.surgeryDoneDetails : 0,
        cataract: value.FinalC[0] != undefined ? value.FinalC[0] : 0,
        cataractDia: value.FinalCD[0] != undefined ? value.FinalCD[0] : 0,
        cataractHyperDia:
          value.FinalCDH[0] != undefined ? value.FinalCDH[0] : 0,
        cataractHyper: value.FinalCH[0] != undefined ? value.FinalCH[0] : 0,
        HyperDia: value.FinalDH[0] != undefined ? value.FinalDH[0] : 0,
      });

      return value;
    });
  } */

  const campSurveyList = useCallback(
    async (data) => {
      const res = await axios.post("getCampSurveyList", data);
      const data_ = res.data.result;
      setCampData(data_);
    },
    [setCampData]
  );

  /* async function campSurveyList(data) {
    await axios.post("getCampSurveyList", data).then((res) => {
      var data_ = res.data.result;
      setCampData(data_);
    });
  } */

  async function getFieldTrack(data) {
    await axios.post("getWorkerList", data).then((res) => {
      var trackingdata = res.data.result.result;
      setAllTrackData(trackingdata);

      var dates = [];
      trackingdata?.map((i) => dates.push(i._id));

      // Convert the date strings to Date objects
      const dateObjects = dates.map(
        (date) => new Date(date.split("-").reverse().join("-"))
      );

      // Find the minimum and maximum dates
      const minDate = new Date(Math.min.apply(null, dateObjects));
      const maxDate = new Date(Math.max.apply(null, dateObjects));

      // Format the dates as strings
      const minDateString = `${minDate.getDate()}-${
        minDate.getMonth() + 1
      }-${minDate.getFullYear()}`;
      const maxDateString = `${maxDate.getDate()}-${
        maxDate.getMonth() + 1
      }-${maxDate.getFullYear()}`;

      setDate({ ...date, minDate: minDate, maxDate: maxDate });
    });
  }



  async function handleReset() {
    setInitialValue({ ...state });
    setInitailDate({ ...filterdate });
    setCamp({ ...camps });
    setDate({ ...defaultMapDates });
    // setVillages([])
    // setHospitals(null)
    setTrackingDate(null);
    setFieldWorkers({ ...fW });
    setIllness({ ...ill });
    setHospitalData(null);
    setHouseHoldData(null);
    setCampData(null);
    setCampDetail(null);
    setcampDataDetail([]);
    setcampRhouse(true);
    setAllTrackData(null);
    setTrackDetail(0);
    setDayTrack(null);
    setfieldWorkerName(null);
    setshiftdetail({ ...shifts });
    setPatientDetails({ ...patientsD });
    setSelectedIll(null);
    // setFieldWorkers(fieldWorkers +1 )
    setReset(!reset);
    setCampreset({
      ...campreset,
      vhv: campreset.vhv + 0.1,
      cbbf: campreset?.cbbf + 0.1,
    });
    setFieldreset({
      ...fieldreset,
      vhv: fieldreset.vhv + 0.1,
      cbbf: fieldreset?.cbbf + 0.1,
    });
    setFiltered(0);
    setVillageReset(villagereset * 0.2);
  }

  const disableDates = (date) => {
    return moment(date).format("DD") > 10 && moment(date).format("DD") < 18;
  };

  const handleCampDropdown = useCallback(
    async (list) => {
      await axios.post("getGISCampList", list).then((res) => {
        var camps = res.data.result.result;

        var vhvvalue = camps?.find((i) => i.camp_type === "VHV");
        var cbbfvalue = camps?.find((i) => i.camp_type === "CBBF");

        vhvvalue = vhvvalue == undefined ? {} : vhvvalue;
        cbbfvalue = cbbfvalue == undefined ? {} : cbbfvalue;

        var select = { camp_place: "Select All", camp_id: "1" };
        vhvvalue?.campList?.unshift(select);
        cbbfvalue?.campList?.unshift(select);

        // Use functional update to avoid stale closure on camp state
        setCamp((prevCamp) => ({ ...prevCamp, vhv: vhvvalue, cbbf: cbbfvalue }));
      });
    },
    [setCamp]
  );

  /* async function handleCampDropdown(list) {
    await axios.post("getGISCampList", list).then((res) => {
      var camps = res.data.result.result;

      var vhvvalue = camps?.find((i) => i.camp_type === "VHV");
      var cbbfvalue = camps?.find((i) => i.camp_type === "CBBF");

      vhvvalue = vhvvalue == undefined ? {} : vhvvalue;
      cbbfvalue = cbbfvalue == undefined ? {} : cbbfvalue;

      var select = { camp_place: "Select All", camp_id: "1" };
      vhvvalue?.campList?.unshift(select);
      cbbfvalue?.campList?.unshift(select);

      setCamp({ ...camp, vhv: vhvvalue, cbbf: cbbfvalue });
    });
  } */

  const handleFieldWorkerDropdown = useCallback(
    async (data) => {
      await axios.post("getGISFieldWorkerList", data).then((res) => {
        var field_w = res.data.result.result;

        var vhvvalue = field_w?.find((i) => i.field_worker_type === "VHV");
        var cbbfvalue = field_w?.find((i) => i.field_worker_type === "CBBF");

        vhvvalue = vhvvalue == undefined ? {} : vhvvalue;
        cbbfvalue = cbbfvalue == undefined ? {} : cbbfvalue;

        // Use functional update to avoid stale closure on fieldWorkers state
        setFieldWorkers((prev) => ({ ...prev, vhv: vhvvalue, cbbf: cbbfvalue }));
      });
    },
    [setFieldWorkers]
  );

  /* async function handleFieldWorkerDropdown(data) {
    await axios.post("getGISFieldWorkerList", data).then((res) => {
      var field_w = res.data.result.result;

      var vhvvalue = field_w?.find((i) => i.field_worker_type === "VHV");
      var cbbfvalue = field_w?.find((i) => i.field_worker_type === "CBBF");

      vhvvalue = vhvvalue == undefined ? {} : vhvvalue;
      cbbfvalue = cbbfvalue == undefined ? {} : cbbfvalue;

      setFieldWorkers({ ...fieldWorkers, vhv: vhvvalue, cbbf: cbbfvalue });
    });
  } */

  const patientsCount = useCallback(
    async (h_data, val) => {
      await axios.post("getMembersCountList", h_data).then((res) => {
        // result can be missing entirely, or contain only VHV or only CBBF —
        // every access below must tolerate that without crashing or
        // producing NaN.
        var data = res?.data?.result || {};
        if (Object.keys(data).length == 0) {
          vhvmale = 0;
          cbbfmale = 0;
          vhvfemale = 0;
          cbbffemale = 0;
          vhvother = 0;
          cbbfother = 0;
          vhvhousehold = 0;
          cbbfhousehold = 0;
          vhvcamp = 0;
          cbbfcamp = 0;
          vhvIndividualHouseHold = 0;
          cbbfIndividualHouseHold = 0;
        } else {
          var vhvdata =
            data["VHV"] && Object.keys(data["VHV"]).length > 0
              ? data["VHV"]
              : 0;
          var cbbfdata =
            data["CBBF"] && Object.keys(data["CBBF"]).length > 0
              ? data["CBBF"]
              : 0;

          var vhvmale =
            vhvdata?.total_males != undefined ? vhvdata?.total_males : 0;
          var cbbfmale =
            cbbfdata?.total_males != undefined ? cbbfdata?.total_males : 0;

          var vhvfemale =
            vhvdata?.total_females != undefined ? vhvdata?.total_females : 0;
          var cbbffemale =
            cbbfdata?.total_females != undefined ? cbbfdata?.total_females : 0;

          var vhvother =
            vhvdata?.total_others != undefined ? vhvdata?.total_others : 0;
          var cbbfother =
            cbbfdata?.total_others != undefined ? cbbfdata?.total_others : 0;

          var vhvhousehold =
            vhvdata?.totalHouseHold != undefined ? vhvdata?.totalHouseHold : 0;
          var cbbfhousehold =
            cbbfdata?.totalHouseHold != undefined
              ? cbbfdata?.totalHouseHold
              : 0;

          var vhvIndividualHouseHold =
            vhvdata?.totalIndividualHouseHold != undefined
              ? vhvdata?.totalIndividualHouseHold
              : 0;
          var cbbfIndividualHouseHold =
            cbbfdata?.totalIndividualHouseHold != undefined
              ? cbbfdata?.totalIndividualHouseHold
              : 0;

          var vhvcamp =
            vhvdata?.totalCamp != undefined ? vhvdata?.totalCamp : 0;
          var cbbfcamp =
            cbbfdata?.totalCamp != undefined ? cbbfdata?.totalCamp : 0;

          vhvmale = vhvmale != undefined ? vhvmale : 0;
          cbbfmale = cbbfmale != undefined ? cbbfmale : 0;
          vhvfemale = vhvfemale != undefined ? vhvfemale : 0;
          cbbffemale = cbbffemale != undefined ? cbbffemale : 0;
          vhvother = vhvother != undefined ? vhvother : 0;
          cbbfother = cbbfother != undefined ? cbbfother : 0;
          vhvhousehold = vhvhousehold != undefined ? vhvhousehold : 0;
          cbbfhousehold = cbbfhousehold != undefined ? cbbfhousehold : 0;
          vhvcamp = vhvcamp != undefined ? vhvcamp : 0;
          cbbfcamp = cbbfcamp != undefined ? cbbfcamp : 0;
        }

        var total_male;
        var total_fmale;
        var t_other;

        if (val == "hospital") {
          total_male = vhvmale + cbbfmale;
          total_fmale = vhvfemale + cbbffemale;
          t_other = vhvother + cbbfother;

          // Use functional update to avoid stale closure on patientDetails state
          setPatientDetails((prev) => ({
            ...prev,
            male: total_male,
            female: total_fmale,
            others: t_other,
            household: vhvhousehold + cbbfhousehold,
            camp: vhvcamp + cbbfcamp,
            individual: vhvIndividualHouseHold + cbbfIndividualHouseHold,
          }));
        } else {
          setPatientDetails((prev) => ({
            ...prev,
            household: vhvhousehold + cbbfhousehold,
            camp: vhvcamp + cbbfcamp,
            individual: vhvIndividualHouseHold + cbbfIndividualHouseHold,
          }));
        }
      });
    },
    [setPatientDetails]
  );

  /* async function patientsCount(h_data, val) {
    await axios.post("getMembersCountList", h_data).then((res) => {
      var data = res.data.result;
      if (Object.keys(data).length == 0) {
        vhvmale = 0;
        cbbfmale = 0;
        vhvfemale = 0;
        cbbffemale = 0;
        vhvother = 0;
        cbbfother = 0;
        vhvhousehold = 0;
        cbbfhousehold = 0;
        vhvcamp = 0;
        cbbfcamp = 0;
      } else {
        var vhvdata = Object.keys(data["VHV"])?.length == 0 ? 0 : data["VHV"];
        var cbbfdata =
          Object.keys(data["CBBF"])?.length == 0 ? 0 : data["CBBF"];

        var vhvmale =
          vhvdata?.total_males != undefined ? vhvdata?.total_males : 0;
        var cbbfmale =
          cbbfdata?.total_males != undefined ? cbbfdata?.total_males : 0;

        var vhvfemale =
          vhvdata?.total_females != undefined ? vhvdata?.total_females : 0;
        var cbbffemale =
          cbbfdata?.total_females != undefined ? cbbfdata?.total_females : 0;

        var vhvother =
          vhvdata?.total_others != undefined ? vhvdata?.total_others : 0;
        var cbbfother =
          cbbfdata?.total_others != undefined ? cbbfdata?.total_others : 0;

        var vhvhousehold =
          vhvdata?.totalHouseHold != undefined ? vhvdata?.totalHouseHold : 0;
        var cbbfhousehold =
          cbbfdata?.totalHouseHold != undefined ? cbbfdata?.totalHouseHold : 0;

        var vhvIndividualHouseHold =
          vhvdata?.totalIndividualHouseHold != undefined
            ? vhvdata?.totalIndividualHouseHold
            : 0;
        var cbbfIndividualHouseHold =
          cbbfdata?.totalIndividualHouseHold != undefined
            ? cbbfdata?.totalIndividualHouseHold
            : 0;

        var vhvcamp = vhvdata?.totalCamp != undefined ? vhvdata?.totalCamp : 0;
        var cbbfcamp =
          cbbfdata?.totalCamp != undefined ? cbbfdata?.totalCamp : 0;

        vhvmale = vhvmale != undefined ? vhvmale : 0;
        cbbfmale = cbbfmale != undefined ? cbbfmale : 0;
        vhvfemale = vhvfemale != undefined ? vhvfemale : 0;
        cbbffemale = cbbffemale != undefined ? cbbffemale : 0;
        vhvother = vhvother != undefined ? vhvother : 0;
        cbbfother = cbbfother != undefined ? cbbfother : 0;
        vhvhousehold = vhvhousehold != undefined ? vhvhousehold : 0;
        cbbfhousehold = cbbfhousehold != undefined ? cbbfhousehold : 0;
        vhvcamp = vhvcamp != undefined ? vhvcamp : 0;
        cbbfcamp = cbbfcamp != undefined ? cbbfcamp : 0;
      }

      var total_male;
      var total_fmale;
      var t_other;

      if (val == "hospital") {
        total_male = vhvmale + cbbfmale;
        total_fmale = vhvfemale + cbbffemale;
        t_other = vhvother + cbbfother;

        setPatientDetails({
          ...patientDetails,
          male: total_male,
          female: total_fmale,
          others: t_other,
          household: vhvhousehold + cbbfhousehold,
          camp: vhvcamp + cbbfcamp,
          individual: vhvIndividualHouseHold + cbbfIndividualHouseHold,
        });
      } else {
        setPatientDetails({
          ...patientDetails,
          household: vhvhousehold + cbbfhousehold,
          camp: vhvcamp + cbbfcamp,
          individual: vhvIndividualHouseHold + cbbfIndividualHouseHold,
        });
      }
    });
  } */

  async function handleChangeHospital(e, data) {
    if (e.target.value != undefined) {
      // to handle no data found

      setTimeout(() => {
        setFiltered(1);
      }, 1000);

      setVillages([]);
      var value = data?.hospital_id;
      setHouseHoldData(null);
      setCampreset({
        ...campreset,
        vhv: campreset.vhv + 0.1,
        cbbf: campreset?.cbbf + 0.1,
      });
      setFieldreset({
        ...fieldreset,
        vhv: fieldreset.vhv + 0.1,
        cbbf: fieldreset?.cbbf + 0.1,
      });
      setCampDetail(null);

      if (value) {
        setInitialValue({ ...state });

        if (value == "1") {
          setHospitalData(hospitals);
          let allHospital = [];

          hospitals?.map((i) => {
            if (i?.hospital_id != "1") {
              allHospital.push(i.hospital_id);
            }
          });

          var hos = {
            hospital_id: allHospital,
          };
          // Include date range if already selected
          if (hasDateRange(initialDate)) {
            hos.fromDate = initialDate.fromDate;
            hos.toDate = initialDate.toDate;
          }

          handleFieldWorkerDropdown(hos);
          handleIllness(hos);
          patientsCount(hos, "hospital");
          handleCampDropdown(hos);

          setInitialValue((i) => ({
            ...i,
            hospital_id: [value],
          }));
        } else {
          setcampDataDetail(data.hospital_name);

          setInitialValue((i) => ({
            ...i,
            hospital_id: [value],
          }));

          var p_load;

          p_load = {
            hospital_id: [value],
          };
          // Include date range if already selected
          if (hasDateRange(initialDate)) {
            p_load.fromDate = initialDate.fromDate;
            p_load.toDate = initialDate.toDate;
          }

          handleFieldWorkerDropdown(p_load);
          handleCampDropdown(p_load);
          loadVillages(p_load);

          var val = hospitals.filter((i) => {
            if (i.hospital_id == value) {
              return i;
            }
          });
          setHospitalData(val);
          campSurveyList(p_load);

          handleIllness(p_load);
          patientsCount(p_load, "hospital");
        }
      }
    }
  }

  function handleDate() {
    if (initialValues.hospital_id == "" && initialValues.camp_id == "") {
      // if (initialValues.fromDate == "" && initialValues.toDate == "") {
      if (initialDate.fromDate == "" && initialDate.toDate == "") {
        const dateConverter = (dateIn) => {
          dateIn.setHours(12);
          let dateFor10days = new Date(dateIn.setDate(dateIn.getDate() - 10));
          return dateFor10days;
        };

        let today = new Date();
        let last10Day = dateConverter(today);

        setInitialValue({
          ...initialValues,
          fromDate: last10Day,
          toDate: today,
        });
      }
    }
  }

  async function handleCampAndFieldWorker(e, camptype, val) {
    if (e.target.value != undefined) {
      // to handle no data found

      setTimeout(() => {
        setFiltered(2);
      }, 1000);

      setTrackingDate(null);
      setHospitalData([]);

      setInitialValue({
        ...initialValues,
        camp_id: [],
      });

      var value = val?.camp_id;

      if (value) {
        if (value == "1" || value == "2") {
          let allCamp = [];
          camp[camptype]?.campList?.map((i) => {
            if (i?.camp_id != "1") {
              allCamp.push(i.camp_id);
            }
          });

          var val = [];
          val.push(value);

          setInitialValue({
            ...initialValues,
            camp_id: val,
            field_worker_id: "",
          });

          var a_camps = {
            camp_id: allCamp,
          };
          campSurveyList(a_camps);
          handleIllness(a_camps);
          handleFieldWorkerDropdown(a_camps);
        } else {
          var camp_d = camp[camptype]?.campList.find((i) => {
            if (i.camp_id == value) {
              return i;
            }
          });

          var hospital_data = hospitals?.find((i) => {
            if (i.hospital_id == camp_d.hospital_id) {
              return i;
            }
          });

          var d = {
            camp_detail: camp_d,
            hospital_detail: hospital_data,
          };

          setCampDetail(camp_d);

          var val = [];
          val.push(value);

          setInitialValue({
            ...initialValues,
            camp_id: val,
            field_worker_id: "",
          });

          var camplist = {};
          if (initialValues.hospital_id?.length == 0) {
            camplist = {
              camp_id: [value],
            };
          } else if (initialValues.hospital_id != "1") {
            camplist = {
              hospital_id: initialValues.hospital_id,
              camp_id: [value],
            };
          } else {
            camplist = {
              camp_id: [value],
            };
          }
          handleIllness(camplist);
          patientsCount(camplist);

          handleFieldWorkerDropdown(camplist);
          campSurveyList(camplist);
          getFieldTrack(camplist);
        }
      }
    }
  }

  async function handleFieldWorkersTrack(e, field_type, value) {
    if (e.target.value != undefined) {
      // to handle no data found

      // value is null when the selection is cleared, and the "No data found"
      // placeholder option has no field_worker_id — both must be ignored.
      var val = value?.field_worker_id;
      if (!val) {
        return;
      }

      setTimeout(() => {
        setFiltered(3);
      }, 1000);

      setTrackingDate(null);

      setInitialValue({ ...initialValues, field_worker_id: val });

      var fieldworkerid = "";

      if (initialValues.camp_id.length == 0) {
        fieldworkerid = {
          field_worker_id: val,
        };
      } else {
        fieldworkerid = {
          field_worker_id: val,
          camp_id: initialValues.camp_id != "1" ? initialValues.camp_id : "",
        };
      }

      var name = fieldWorkers[field_type]?.filed_workerList?.find((i) => {
        if (i.field_worker_id == val) {
          return i;
        }
      });
      setfieldWorkerName(name?.field_worker_name || null);

      getFieldTrack(fieldworkerid);

      patientsCount(fieldworkerid);
    }
  }

  function villageChange(e, val) {
    if (e.target.value != undefined) {
      // to handle no data found

      setTimeout(() => {
        setFiltered(4);
      }, 1000);

      var value = val?.village_id;
      if (value == null) {
        value = "";
      }
      setVillageId(value);
    }
  }

  const handleDetail = useCallback((val, type) => {
    if (type == "household") {
      setcampRhouse(false);

      setHouseHoldData(val);
    } else {
      setcampRhouse(true);
      setcampDataDetail(val);
    }
  }, []);

  function firstLetter(s) {
    if (s != undefined && s != null && s?.length > 0) {
      return s?.replace(/^.{1}/g, s[0]?.toUpperCase());
    }
  }

  function handleTrackingDate(e) {
    // e is null on clear and an invalid dayjs while typing — date-fns
    // format() throws a RangeError on an invalid Date.
    if (!e || !e.isValid()) {
      setTrackingDate(null);
      return;
    }
    setTrackingDate(e.$d);
    var date = format(new Date(e.$d), dateFormat);
    var dateValue = new Date(new Date(e.$d).setHours(6, 0, 0));

    var list = {
      field_worker_id: initialValues.field_worker_id,
      fromDate: dateValue,
      toDate: dateValue,
    };

    patientsCount(list);

    date = date?.replaceAll("/", "-");

    var detail = allTrackData?.find((i) => i._id == date);

    let dd = {
      ...detail,
      coords: detail?.coords?.filter((x) => x.current_latitude != "0.0"),
    };

    setDayTrack(dd);
    setTrackDetail(dd);

    var shiftin = dd?.coords?.find((i) => {
      if (i.event.replace(/ /g, "").toLowerCase() == "punchin") {
        return i;
      }
    });
    var shiftout = dd?.coords?.find((i) => {
      if (i.event.replace(/ /g, "").toLowerCase() == "punchout") {
        return i;
      }
    });

    var inn;
    var out;

    inn = shiftin != undefined ? convertTime(shiftin?.loc_entry_time) : "";
    out = shiftout != undefined ? convertTime(shiftout?.loc_entry_time) : "";

    //================= convert into indian standart time ==================

    // dayjs.extend(utc);

    // var inn = shiftin != undefined ? dayjs.utc(shiftin?.loc_entry_time).local().format('h:mm A') : null;
    // var out = shiftout != undefined ? dayjs.utc(shiftout?.loc_entry_time).local().format('h:mm A') : null;

    // ======================================================================

    setshiftdetail({ ...shiftdetail, shiftIn: inn, shiftout: out });
  }

  function convertTime(time) {
    var currentDate = new Date(time);
    var hours = currentDate.getUTCHours();
    var minutes = currentDate.getUTCMinutes();

    var amOrPm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12;
    hours = hours ? hours : 12; // Convert 0 to 12

    var time =
      hours.toString().padStart(2, "0") +
      ":" +
      minutes.toString().padStart(2, "0") +
      " " +
      amOrPm;

    return time;
  }

  const handleselectedHospital = useCallback(
    (value) => {
      // Call other functions and set state
      campSurveyList(value);
      handleCampDropdown(value);
      handleFieldWorkerDropdown(value);
      handleIllness(value);
      patientsCount(value, "hospital");
      setInitialValue((prevValues) => ({
        ...prevValues,
        hospital_id: value.hospital_id,
      }));
    },
    [
      campSurveyList,
      handleCampDropdown,
      handleFieldWorkerDropdown,
      handleIllness,
      patientsCount,
    ]
  );

  function handleHeatMap(ill) {
    setSelectedIll(ill);
  }

  const MemoizedMap = useMemo(
    () => (
      <Map
        reset={reset}
        hospitalData={hospitalData}
        detailData={handleDetail}
        heatMap={illness}
        tracking={daytrack}
        selectedHospital={handleselectedHospital}
        campData={campData}
      />
    ),
    [
      reset,
      hospitalData,
      handleDetail,
      illness,
      daytrack,
      handleselectedHospital,
      campData,
    ]
  );

  const handleInputChange = async (event) => {
    const inputValue = event.target.value;
    if (inputValue.length == 0) {
      // if empty or no letters are types
      setCamp({ ...camp, vhv: [], cbbf: [] });
    }

    if (inputValue.length > 0) {
      if (inputValue.length % 3 == 0) {
        var data = {
          search: inputValue,
        };
        // Keep the search inside the currently applied filters — a global
        // search would silently show camps outside the selected hospital
        // and date range.
        const realHospitalIds = Array.isArray(initialValues.hospital_id)
          ? initialValues.hospital_id.filter((id) => id && id !== "1")
          : [];
        if (realHospitalIds.length > 0) {
          data.hospital_id = realHospitalIds;
        }
        if (hasDateRange(initialDate)) {
          data.fromDate = initialDate.fromDate;
          data.toDate = initialDate.toDate;
        }

        handleCampDropdown(data);
      }
    }
  };

  const handleVillageChange = async (event) => {
    const inputValue = event.target.value;

    if (inputValue) {
      if (inputValue.length > 0) {
        if (inputValue.length % 3 == 0) {
          var data = {
            search: inputValue,
          };

          // hospital_id is already an array — do not wrap it again — and the
          // Select-All sentinel "1" is not a real id the backend can use.
          const realHospitalIds = Array.isArray(initialValues.hospital_id)
            ? initialValues.hospital_id.filter((id) => id && id !== "1")
            : [];
          if (realHospitalIds.length > 0) {
            data.hospital_id = realHospitalIds;
          }

          loadVillages(data);
        }
      } else {
        setVillages([]);
      }
    }
  };

  const vhvCount =
    camp?.vhv?.campList?.filter((item) => item.camp_place !== "Select All")
      ?.length || 0;

  const cbbfCount =
    camp?.cbbf?.campList?.filter((item) => item.camp_place !== "Select All")
      ?.length || 0;

  return (
    <>
      <Formik initialValues={initialValues}>
        {({ isSubmitting, setFieldValue, values }) => (
          <div className="gis">
            <div
              className={filter ? "arrow" : "arrowin"}
              onClick={() => setFilter(!filter)}
            >
              <ArrowLeft />
            </div>
            <div
              className={filter ? "gis_filter" : "gis_filter_in"}
              onMouseLeave={() => {
                setTimeout(() => {
                  setFilter(!filter);
                }, 2000);
              }}
            >
              <div className="filter_head">
                <div className="head" onClick={() => navigate("/masters")}>
                  <img
                    src={logo}
                    width="50"
                    height={50}
                    style={{ borderRadius: "50%" }}
                    alt="Servis"
                  />
                </div>

                {/* <div className={filtered == 1 ? 'head bg' : 'head'} onClick={() => setFiltered(1)}>
                  <LocalHospital />
                </div>
                <div className={filtered == 2 ? 'head bg' : 'head'} onClick={() => setFiltered(2)}>
                  <Festival />
                </div>
                <div className={filtered == 3 ? 'head bg' : 'head'} onClick={() => setFiltered(3)}>
                  <AssignmentInd />
                </div>*/}
              </div>
              <div className="filter_body">
                <div>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      className="from_date"
                      value={
                        initialDate.fromDate == "" ? null : initialDate.fromDate
                      }
                      inputFormat="DD/MM/YYYY"
                      onChange={(e) => {
                        // e is a dayjs object or null (Clear); "" is the empty
                        // sentinel expected by hasDateRange and handleReset
                        const selectedDate =
                          e && e.isValid() ? e.$d : "";
                        setInitailDate({
                          ...initialDate,
                          fromDate: selectedDate,
                        });
                      }}
                      componentsProps={{
                        // v5 API: slotProps only exists in @mui/x-date-pickers v6+
                        actionBar: {
                          actions: ["clear"],
                        },
                      }}
                      renderInput={(props) =>
                        renderInputs(props, "From date", "date")
                      }
                    />
                  </LocalizationProvider>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      className="from_date"
                      value={
                        initialDate.toDate == "" ? null : initialDate.toDate
                      }
                      inputFormat="DD/MM/YYYY"
                      onChange={(e) => {
                        // e is a dayjs object or null (Clear); "" is the empty
                        // sentinel expected by hasDateRange and handleReset
                        const selectedDate =
                          e && e.isValid() ? e.$d : "";
                        setInitailDate({ ...initialDate, toDate: selectedDate });
                      }}
                      componentsProps={{
                        // v5 API: slotProps only exists in @mui/x-date-pickers v6+
                        actionBar: {
                          actions: ["clear"],
                        },
                      }}
                      renderInput={(props) =>
                        renderInputs(props, "To date", "date")
                      }
                    />
                  </LocalizationProvider>
                </div>
                <div className="icons">
                  <LocalHospital />
                </div>
                <div>
                  <Autocomplete
                    size="small"
                    disablePortal
                    className="hide"
                    variant="standard"
                    id="combo-box-demo"
                    sx={{
                      input: {
                        "&::placeholder": {
                          // <----- Add this.
                          opacity: 1,
                          // marginBottom: '-5px',
                          color: "#000",
                        },
                      },
                      backgroundColor: "#ffffff",
                      // borderRadius: '5px',
                      width: "90%",
                    }}
                    ListboxProps={{
                      sx: { fontSize: 13 },
                    }}
                    options={
                      hospitals?.length > 0
                        ? hospitals
                        : [{ hospital_name: "No data found" }]
                    }
                    value={
                      initialValues.hospital_id?.length == 0
                        ? null
                        : hospitals?.find(
                            (h) => h.hospital_id === initialValues.hospital_id[0]
                          ) || null
                    }
                    key={reset}
                    getOptionLabel={(option) =>
                      option.hospital_name?.charAt(0)?.toUpperCase() +
                      option.hospital_name?.slice(1)
                    }
                    onChange={(data, value) => {
                      handleChangeHospital(data, value);
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        color="black"
                        InputLabelProps={{
                          // shrink: false,
                          style: {
                            fontSize: "13px", // Adjust the font size of the label here
                            paddingTop: "5px",
                          },
                        }}
                        label="Select Hospitals"
                      />
                    )}
                  />
                </div>
                {/* VHV Camp Section */}
                <div className="icons">
                  <Festival />
                </div>
                <div>
                  <Autocomplete
                    size="small"
                    disablePortal
                    className="date"
                    variant="standard"
                    id="vhv-camp-select"
                    key={campreset?.vhv}
                    sx={{
                      input: {
                        "&::placeholder": {
                          opacity: 1,
                          marginBottom: "-5px",
                        },
                      },
                      backgroundColor: "#ffffff",
                      width: "90%",
                      margin: "0 5px",
                    }}
                    ListboxProps={{
                      sx: {
                        fontSize: 13,
                        "& li": {
                          textAlign: "left",
                          whiteSpace: "normal",
                          wordBreak: "break-word",
                          alignItems: "flex-start",
                        },
                      },
                    }}
                    options={
                      camp?.vhv?.campList?.length > 0
                        ? camp?.vhv?.campList
                        : [{ camp_place: "No data found" }]
                    }
                    onInputChange={(e) => handleInputChange(e)}
                    value={
                      initialValues.camp_id?.length == 0
                        ? null
                        : camp?.vhv?.campList?.find(
                            (c) => c.camp_id === initialValues.camp_id[0]
                          ) || null
                    }
                    getOptionLabel={(option) =>
                      option.camp_place?.charAt(0)?.toUpperCase() +
                      option.camp_place?.slice(1)
                    }
                    onChange={(data, value) => {
                      handleCampAndFieldWorker(data, "vhv", value);
                    }}
                    renderOption={(props, option) => {
                      return (
                        <li
                          {...props}
                          key={option.camp_id}
                          style={{
                            ...props.style,
                            textAlign: "left",
                            whiteSpace: "normal",
                            wordBreak: "break-word",
                            alignItems: "flex-start",
                            lineHeight: "1.4",
                            padding: "6px 10px",
                          }}
                        >
                          {option.camp_place}
                        </li>
                      );
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        color="black"
                        InputLabelProps={{
                          style: {
                            fontSize: "13px",
                            paddingTop: "5px",
                          },
                        }}
                        label="Select VHV Camp"
                      />
                    )}
                  />
                  <Autocomplete
                    size="small"
                    disablePortal
                    className="date"
                    variant="standard"
                    id="volunteers-camp-select"
                    sx={{
                      input: {
                        "&::placeholder": {
                          opacity: 1,
                          marginBottom: "-5px",
                        },
                      },
                      backgroundColor: "#ffffff",
                      margin: "0 5px",
                      width: "90%",
                    }}
                    key={campreset?.cbbf}
                    ListboxProps={{
                      sx: {
                        fontSize: 13,
                        "& li": {
                          textAlign: "left",
                          whiteSpace: "normal",
                          wordBreak: "break-word",
                          alignItems: "flex-start",
                        },
                      },
                    }}
                    options={
                      camp?.cbbf?.campList?.length > 0
                        ? camp?.cbbf?.campList
                        : [{ camp_place: "No data found" }]
                    }
                    value={
                      initialValues.camp_id?.length == 0
                        ? null
                        : camp?.cbbf?.campList?.find(
                            (c) => c.camp_id === initialValues.camp_id[0]
                          ) || null
                    }
                    getOptionLabel={(option) =>
                      option.camp_place?.charAt(0)?.toUpperCase() +
                      option.camp_place?.slice(1)
                    }
                    onInputChange={(e) => handleInputChange(e)}
                    onChange={(data, value) => {
                      handleCampAndFieldWorker(data, "cbbf", value);
                    }}
                    renderOption={(props, option) => {
                      return (
                        <li
                          {...props}
                          key={option.camp_id}
                          style={{
                            ...props.style,
                            textAlign: "left",
                            whiteSpace: "normal",
                            wordBreak: "break-word",
                            alignItems: "flex-start",
                            lineHeight: "1.4",
                            padding: "6px 10px",
                          }}
                        >
                          {option.camp_place}
                        </li>
                      );
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        color="black"
                        InputLabelProps={{
                          style: {
                            fontSize: "13px",
                            paddingTop: "5px",
                          },
                        }}
                        label="Select Volunteers Camp"
                      />
                    )}
                  />
                </div>
                <div className="icons">
                  <AssignmentInd />
                </div>
                <div>
                  <Autocomplete
                    size="small"
                    disablePortal
                    className="date"
                    variant="standard"
                    id="combo-box-demo"
                    sx={{
                      input: {
                        "&::placeholder": {
                          // <----- Add this.
                          opacity: 1,
                          marginBottom: "-5px",
                          fontSize: "10px",
                        },
                      },
                      backgroundColor: "#ffffff",
                      margin: " 0 5px",
                      // borderRadius: '5px',
                      width: "90%",
                    }}
                    key={fieldreset?.vhv}
                    ListboxProps={{
                      sx: { fontSize: 13 },
                    }}
                    options={
                      fieldWorkers?.vhv?.filed_workerList?.length > 0
                        ? fieldWorkers?.vhv?.filed_workerList
                        : [{ field_worker_name: "No data found" }]
                    }
                    getOptionLabel={(option) => option.field_worker_name}
                    value={
                      initialValues?.field_worker_id == ""
                        ? null
                        : fieldWorkers?.vhv?.filed_workerList?.find(
                            (f) => f.field_worker_id === initialValues.field_worker_id
                          ) || null
                    }
                    onChange={(data, value) => {
                      handleFieldWorkersTrack(data, "vhv", value);
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        InputLabelProps={{
                          // shrink: false,
                          style: {
                            fontSize: "13px", // Adjust the font size of the label here
                            paddingTop: "5px",
                          },
                        }}
                        label="Select VHV FieldWorker"
                      />
                    )}
                  />

                  <Autocomplete
                    size="small"
                    disablePortal
                    className="date"
                    variant="standard"
                    id="combo-box-demo"
                    sx={{
                      input: {
                        "&::placeholder": {
                          opacity: 1,
                          marginBottom: "-5px",
                        },
                      },
                      backgroundColor: "#ffffff",
                      margin: " 0 5px",
                      // borderRadius: '5px',
                      width: "90%",
                    }}
                    key={fieldreset?.cbbf}
                    ListboxProps={{
                      sx: { fontSize: 13 },
                    }}
                    options={
                      fieldWorkers?.cbbf?.filed_workerList?.length > 0
                        ? fieldWorkers?.cbbf?.filed_workerList
                        : [{ field_worker_name: "No data found" }]
                    }
                    getOptionLabel={(option) => option.field_worker_name}
                    value={
                      initialValues?.field_worker_id == ""
                        ? null
                        : fieldWorkers?.cbbf?.filed_workerList?.find(
                            (f) => f.field_worker_id === initialValues.field_worker_id
                          ) || null
                    }
                    onChange={(data, value) => {
                      handleFieldWorkersTrack(data, "cbbf", value);
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        color="black"
                        InputLabelProps={{
                          // shrink: false,
                          style: {
                            fontSize: "13px", // Adjust the font size of the label here
                            paddingTop: "5px",
                          },
                        }}
                        /* label="Select CBBF FieldWorker" */
                        label="Select Volunteers FieldWorker"
                      />
                    )}
                  />
                </div>
                {initialValues.field_worker_id !== "" ? (
                  <div>
                    <LocalizationProvider
                      size="small"
                      dateAdapter={AdapterDayjs}
                    >
                      <DatePicker
                        className="from_date"
                        value={trackingDate}
                        inputFormat="DD/MM/YYYY"
                        onChange={(e) => {
                          handleTrackingDate(e);
                        }}
                        defaultValue={null}
                        disabled={initialValues.field_worker_id == ""}
                        minDate={date?.minDate}
                        maxDate={date?.maxDate}
                        renderInput={(props) =>
                          renderInputs(props, "Date", "fieldDate")
                        } // props , lablename , classname
                      />
                    </LocalizationProvider>
                  </div>
                ) : (
                  ""
                )}
                <div>
                  <Autocomplete
                    size="small"
                    // disablePortal
                    className="hide"
                    variant="standard"
                    id="combo-box-demo"
                    sx={{
                      input: {
                        "&::placeholder": {
                          // <----- Add this.
                          opacity: 1,
                          // marginBottom: '-5px',
                          color: "#000000",
                        },
                      },
                      backgroundColor: "#ffffff",
                      // borderRadius: '5px',
                      width: "90%",
                      // '& .MuiAutocomplete-input, & .MuiInputLabel-root': {
                      //   fontSize: 10,
                      // },
                    }}
                    ListboxProps={{
                      sx: { fontSize: 13 },
                    }}
                    options={
                      villages?.length > 0
                        ? villages
                        : [{ village_name: "No data found" }]
                    }
                    key={villagereset}
                    getOptionLabel={(option) =>
                      option.village_name?.charAt(0)?.toUpperCase() +
                      option.village_name?.slice(1)
                    }
                    onChange={(data, value) => {
                      villageChange(data, value);
                    }}
                    onInputChange={(e) => handleVillageChange(e)}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        color="black"
                        InputLabelProps={{
                          // shrink: false,
                          style: {
                            fontSize: "13px", // Adjust the font size of the label here
                            paddingTop: "5px",
                            zIndex: "2",
                          },
                        }}
                        label="Select Location"
                      />
                    )}
                  />
                </div>
              </div>
              <Button
                variant="contained"
                sx={{
                  float: "right",
                  m: 1,
                  width: "8ch",
                  textTransform: "none",
                }}
                onClick={() => handleReset()}
                className="search_btn reset"
              >
                {" "}
                Reset{" "}
              </Button>
            </div>
            <div className="map_section">
              {/* <Map reset={reset} hospitalData={hospitalData} detailData={(val, type) => handleDetail(val, type)} heatMap={illness} tracking={daytrack} selectedHospital={(data) => handleselectedHospital(data)} campData={campData} /> */}
              {MemoizedMap}
              <div className="commondetails_">
                <div className="map_details">
                  <div
                    className={
                      filtered == 1 ||
                      filtered == 2 ||
                      filtered == 3 ||
                      filtered == 4
                        ? "hos anime"
                        : "hos vhidden"
                    }
                  >
                    <div className="symbol">
                      <LocalHospital style={{ width: "60%" }} />
                    </div>
                    <div className="card_">
                      <div className=" section_">
                        {" "}
                        {/*icon_*/}
                        <LocalHospital />
                        <Typography
                          variant="subtitle2"
                          sx={{ fontWeight: "bold" }}
                        >
                          Hospital Name
                        </Typography>
                        <Typography variant="caption">
                          {hospitalData?.length <= 1
                            ? hospitalData[0]?.hospital_name == "" ||
                              hospitalData[0]?.hospital_name == undefined
                              ? firstLetter(campDataDetail)
                              : firstLetter(hospitalData[0]?.hospital_name)
                            : "All"}
                        </Typography>
                      </div>
                      <div className=" section_">
                        {" "}
                        {/*icon_*/}
                        <Festival />
                        <Typography
                          variant="subtitle2"
                          sx={{ fontWeight: "bold" }}
                        >
                          Total Camp{" "}
                        </Typography>
                        <Typography variant="caption">
                          {vhvCount + cbbfCount}
                        </Typography>
                      </div>
                      <div className=" section_">
                        {" "}
                        {/*icon_*/}
                        <Male />
                        <Typography
                          variant="subtitle2"
                          sx={{ fontWeight: "bold" }}
                        >
                          Total Males{" "}
                        </Typography>
                        <Typography variant="caption">
                          {patientDetails?.male}
                        </Typography>
                      </div>
                      <div className=" section_">
                        {" "}
                        {/*icon_*/}
                        <FemaleTwoTone />
                        <Typography
                          variant="subtitle2"
                          sx={{ fontWeight: "bold" }}
                        >
                          Total Females{" "}
                        </Typography>
                        <Typography variant="caption">
                          {patientDetails?.female}
                        </Typography>
                      </div>
                      <div className=" section_">
                        {" "}
                        {/*icon_*/}
                        <TransgenderTwoTone />
                        <Typography
                          variant="subtitle2"
                          sx={{ fontWeight: "bold" }}
                        >
                          Others{" "}
                        </Typography>
                        <Typography variant="caption">
                          {patientDetails?.others}
                        </Typography>
                      </div>
                    </div>
                  </div>

                  <div
                    className={
                      filtered == 2 || filtered == 3 || filtered == 4
                        ? "camp anime"
                        : "camp vhidden"
                    }
                  >
                    <Festival />
                    <div className="card_">
                      <div className=" section_">
                        {" "}
                        {/*icon_*/}
                        <Festival />
                        <Typography
                          variant="subtitle2"
                          sx={{ fontWeight: "bold" }}
                        >
                          Camp Name
                        </Typography>
                        <Typography variant="caption">
                          {firstLetter(campDetail?.camp_place)}
                        </Typography>
                      </div>
                      {campDataDetail != "" && (
                        <div className=" section_">
                          {" "}
                          {/*icon_*/}
                          <LocalHospitalSharp />
                          <Typography
                            variant="subtitle2"
                            sx={{ fontWeight: "bold" }}
                          >
                            Assigned Hospital
                          </Typography>
                          <Typography variant="caption">
                            {firstLetter(campDataDetail)}
                          </Typography>
                        </div>
                      )}

                      <div className=" section_">
                        {" "}
                        {/*icon_*/}
                        <HomeTwoToneIcon />
                        <Typography
                          variant="subtitle2"
                          sx={{ fontWeight: "bold" }}
                        >
                          Total Household{" "}
                        </Typography>
                        <Typography variant="caption">
                          {patientDetails?.household}
                        </Typography>
                      </div>
                      <div className=" section_">
                        {" "}
                        {/*icon_*/}
                        <HomeTwoToneIcon />
                        <Typography
                          variant="subtitle2"
                          sx={{ fontWeight: "bold" }}
                        >
                          Total Individuals{" "}
                        </Typography>
                        <Typography variant="caption">
                          {patientDetails?.individual}
                        </Typography>
                      </div>
                      <div className=" section_">
                        {" "}
                        {/*icon_*/}
                        <BiRename />
                        <Typography
                          variant="subtitle2"
                          sx={{ fontWeight: "bold" }}
                        >
                          Patient name
                        </Typography>
                        <Typography variant="caption">
                          {firstLetter(houseHoldData?.name)}
                        </Typography>
                      </div>
                      <div className=" section_">
                        {" "}
                        {/*icon_*/}
                        <TransgenderTwoTone />
                        <Typography
                          variant="subtitle2"
                          sx={{ fontWeight: "bold" }}
                        >
                          Patient age{" "}
                        </Typography>
                        <Typography variant="caption">
                          {houseHoldData?.age}
                        </Typography>
                      </div>
                    </div>
                  </div>
                  {/* <div className="filedworker">  */}
                  <div
                    className={
                      filtered == 3 || filtered == 4
                        ? "filedworker anime"
                        : " filedworker vhidden"
                    }
                  >
                    <DirectionsBike />
                    <div className="card_">
                      <div className=" section_">
                        {" "}
                        {/*icon_*/}
                        <TwoWheeler />
                        <Typography
                          variant="subtitle2"
                          sx={{ fontWeight: "bold" }}
                        >
                          Travelled Km
                        </Typography>
                        <Typography variant="caption">
                          {trackDetail != ""
                            ? trackDetail?.traveledDistance?.toFixed(2)
                            : 0}{" "}
                          km
                        </Typography>
                      </div>
                      <div className=" section_">
                        {" "}
                        {/*icon_*/}
                        <BiRename />
                        <Typography
                          variant="subtitle2"
                          sx={{ fontWeight: "bold" }}
                        >
                          Field Worker Name{" "}
                        </Typography>
                        <Typography variant="caption">
                          {fieldWorkerName}
                        </Typography>
                      </div>
                      <div className=" section_">
                        {" "}
                        {/*icon_*/}
                        <AiOutlineCaretRight />
                        <Typography
                          variant="subtitle2"
                          sx={{ fontWeight: "bold" }}
                        >
                          Shift In
                        </Typography>
                        <Typography variant="caption">
                          {shiftdetail?.shiftIn}{" "}
                        </Typography>
                      </div>
                      <div className=" section_">
                        {" "}
                        {/*icon_*/}
                        <AiOutlineCaretLeft />
                        <Typography
                          variant="subtitle2"
                          sx={{ fontWeight: "bold" }}
                        >
                          Shift out
                        </Typography>
                        <Typography variant="caption">
                          {shiftdetail?.shiftout}{" "}
                        </Typography>
                      </div>
                      <div className=" section_">
                        {" "}
                        {/*icon_*/}
                        <HomeTwoToneIcon />
                        <Typography
                          variant="subtitle2"
                          sx={{ fontWeight: "bold" }}
                        >
                          Total Household{" "}
                        </Typography>
                        <Typography variant="caption">
                          {patientDetails?.household}
                        </Typography>
                      </div>
                    </div>
                  </div>
                  <div
                    className={
                      filtered == 4 ? "illness anime" : " illness vhidden"
                    }
                  >
                    <div className="card_">
                      <div className=" section_">
                        {" "}
                        {/*icon_*/}
                        <Typography
                          variant="subtitle2"
                          sx={{ fontWeight: "bold" }}
                        >
                          Cataract Identified
                        </Typography>
                        <Typography variant="caption">
                          {illness?.cataract?.count == undefined
                            ? 0
                            : illness?.cataract?.count}
                        </Typography>
                      </div>
                      <div className=" section_">
                        {" "}
                        {/*icon_*/}
                        <Typography
                          variant="subtitle2"
                          sx={{ fontWeight: "bold" }}
                        >
                          Cataract Surgery Done
                        </Typography>
                        <Typography variant="caption">
                          {illness?.surgerydonedetails?.surgery_done_count ==
                          undefined
                            ? 0
                            : illness?.surgerydonedetails?.surgery_done_count}
                        </Typography>
                      </div>
                      <div className=" section_">
                        {" "}
                        {/*icon_*/}
                        <Typography
                          variant="subtitle2"
                          sx={{ fontWeight: "bold" }}
                        >
                          Diabetes
                        </Typography>
                        <Typography variant="caption">
                          {illness?.diabetes?.count == undefined
                            ? 0
                            : illness?.diabetes?.count}
                        </Typography>
                      </div>
                      <div className=" section_">
                        {" "}
                        {/*icon_*/}
                        <Typography
                          variant="subtitle2"
                          sx={{ fontWeight: "bold" }}
                        >
                          Hypertension
                        </Typography>
                        <Typography variant="caption">
                          {illness?.hypertension?.count == undefined
                            ? 0
                            : illness?.hypertension?.count}
                        </Typography>
                      </div>
                      <div className=" section_">
                        {" "}
                        {/*icon_*/}
                        <Typography
                          variant="subtitle2"
                          sx={{ fontWeight: "bold" }}
                        >
                          Cataract & Diabetes
                        </Typography>
                        <Typography variant="caption">
                          {illness?.cataractDia?.count == undefined
                            ? 0
                            : illness?.cataractDia?.count}
                        </Typography>
                      </div>
                      <div className=" section_">
                        {" "}
                        {/*icon_*/}
                        <Typography
                          variant="subtitle2"
                          sx={{ fontWeight: "bold" }}
                        >
                          Hypertension & Diabetes
                        </Typography>
                        <Typography variant="caption">
                          {illness?.HyperDia?.count == undefined
                            ? 0
                            : illness?.HyperDia?.count}
                        </Typography>
                      </div>
                      <div className=" section_">
                        {" "}
                        {/*icon_*/}
                        <Typography
                          variant="subtitle2"
                          sx={{ fontWeight: "bold" }}
                        >
                          Cataract & Hypertension & Diabetes{" "}
                        </Typography>
                        <Typography variant="caption">
                          {illness?.cataractHyperDia?.count == undefined
                            ? 0
                            : illness?.cataractHyperDia?.count}
                        </Typography>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </Formik>
    </>
  );
};

export default Gis_report;
